module.exports = __webpack_public_path__ + "media/app/images/person-48-d92259064870317d296b2e77ac2f7b2a.png";